import React from 'react'
import { Text } from '@mote/ui'

export const textDefaultProps = {
  as: 'span',
  fontSize: 20,
  fontWeight: 500,
  lineHeight: '140%',
  alignment: 'center'
}

export const Hint = props => (
  <Text
    {...textDefaultProps}
    fontSize={14}
    fontWeight={400}
    color='grey.d1'
    {...props}
  />
)
